(() => {
  if (window.eaunexaPackCartLoaded) return;
  window.eaunexaPackCartLoaded = true;

  const buildItems = (picker, option) => {
    if (!option || option.dataset.available !== 'true') return [];
    if (picker.hasAttribute('data-eaunexa-filter-bundle')) {
      const id = Number(option.dataset.variantId);
      return Number.isSafeInteger(id) && id > 0 ? [{ id, quantity: 1 }] : [];
    }

    const kitId = Number(picker.dataset.kitVariantId);
    if (!Number.isSafeInteger(kitId) || kitId <= 0) return [];
    const properties = { 'Pack EAUNEPUR': option.dataset.packLabel };
    const items = [{ id: kitId, quantity: 1, properties }];
    if (option.value !== 'essentiel') {
      const rechargeId = Number(option.dataset.bundleVariantId);
      if (!Number.isSafeInteger(rechargeId) || rechargeId <= 0) return [];
      const rechargeQuantity = Number(option.dataset.bundleQuantity || 1);
      if (!Number.isSafeInteger(rechargeQuantity) || rechargeQuantity <= 0) return [];
      items.push({ id: rechargeId, quantity: rechargeQuantity, properties });
    }
    return items;
  };

  const addItems = (body) => new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open('POST', window.routes?.cart_add_url || '/cart/add.js', true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('Accept', 'application/json');
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.timeout = 30000;
    request.onload = () => {
      let result;
      try { result = JSON.parse(request.responseText); } catch (_) { /* La réponse n’est pas exploitable. */ }
      if (request.status >= 200 && request.status < 300 && !result?.status) {
        resolve(result || {});
      } else {
        const error = new Error('Le pack n’a pas pu être ajouté. Vérifiez sa disponibilité puis réessayez.');
        if (typeof result?.description === 'string') error.message = result.description;
        reject(error);
      }
    };
    const confirmationError = () => reject(new Error('La confirmation n’a pas pu être reçue. Vérifiez votre panier avant de réessayer pour éviter un ajout en double.'));
    request.onerror = confirmationError;
    request.ontimeout = confirmationError;
    request.send(JSON.stringify(body));
  });

  const initialise = (picker) => {
    if (picker.dataset.packCartReady === 'true') return;
    const submit = picker.querySelector('[data-eaunexa-pack-submit]');
    const status = picker.querySelector('[data-eaunexa-pack-status]');
    const summary = picker.querySelector('[data-eaunexa-pack-summary]');
    const total = picker.querySelector('[data-eaunexa-pack-total]');
    const cartLink = picker.querySelector('[data-eaunexa-pack-cart-link]');
    const choices = picker.querySelector('fieldset');
    if (!submit || !status || !choices) return;
    picker.dataset.packCartReady = 'true';
    let busy = false;

    const selected = () => picker.querySelector('[data-eaunexa-pack-option]:checked');
    const updateSelection = () => {
      const option = selected();
      const available = buildItems(picker, option).length > 0;
      const description = option?.closest('label')?.querySelector('.eaunexa-bundle__copy > span, .eaunexa-filter-bundle__copy > span')?.textContent.trim();
      if (summary) summary.textContent = `Total du pack : ${description || option?.dataset.packLabel || ''}`;
      if (total) total.textContent = option?.dataset.priceLabel || 'Prix indisponible';
      submit.disabled = busy || !available;
      submit.textContent = available ? `Ajouter ${option.value === 'unite' ? '' : 'le '}${option.dataset.packLabel} : ${option.dataset.priceLabel}` : 'Pack momentanément indisponible';
      if (!busy) status.textContent = available ? '' : 'Ce pack n’est pas disponible actuellement. Choisissez un autre pack ou contactez-nous.';
    };

    picker.addEventListener('change', (event) => {
      if (event.target.matches('[data-eaunexa-pack-option]')) updateSelection();
    });

    submit.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || submit.disabled) return;
      const option = selected();
      const items = buildItems(picker, option);
      if (!items.length) { updateSelection(); return; }

      busy = true;
      choices.disabled = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Ajout en cours…';
      status.textContent = 'Ajout du pack au panier…';
      if (cartLink) cartLink.hidden = true;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items };
      if (cart?.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement?.(submit);
      }

      try {
        const response = await addItems(body);
        status.textContent = `${option.dataset.packLabel} ${option.value === 'unite' ? 'ajoutée' : 'ajouté'} au panier.`;
        if (cartLink) cartLink.hidden = false;
        if (cart?.renderContents && response.sections) {
          try {
            cart.classList.remove('is-empty');
            cart.renderContents({ ...response, key: response.key || response.items?.[0]?.key });
          } catch (_) {
            // L’ajout a réussi. Le lien panier reste disponible si la notification ne peut pas s’ouvrir.
          }
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve().then(() => publish(PUB_SUB_EVENTS.cartUpdate, { source: 'eaunexa-pack', cartData: response })).catch(() => {});
        }
      } catch (error) {
        status.textContent = error.message;
        if (cartLink) cartLink.hidden = false;
      } finally {
        busy = false;
        choices.disabled = false;
        submit.removeAttribute('aria-busy');
        const message = status.textContent;
        updateSelection();
        status.textContent = message;
      }
    });

    updateSelection();
  };

  const initialiseAll = () => document.querySelectorAll('[data-eaunexa-pack-picker]').forEach(initialise);
  initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
